import {
  AryaPictureBook,
  type AryaPictureBookConfig,
  type AryaPictureBookProps,
} from './AryaSvarnamanjushaBook';

const RAHASYAMAYI_GUHA_CONFIG: AryaPictureBookConfig = {
  slug: 'arya-rahasyamayi-guha',
  filename: 'arya_rahasyamayi_guha_book.pdf',
  gateTitle: 'आर्य और रहस्यमयी गुहा',
  fullTitle: 'आर्य और रहस्यमयी गुहा — गुहा-अन्वेषण',
  subtitle: 'Amarakosha — Viśeṣyanighna · श्लोक २०३७–२०४०',
  headerMeta: 'एक रहस्यमय चित्र आर्य को पर्वतीय गुहा की ओर बुलाता है — १७ शक्ति-शब्द, २४ चित्र-पृष्ठ, ३–८ वर्ष के बालकों के लिए।',
  contentsHi: [
    'आर्य का पर्वतीय गुहा-अन्वेषण — मुनि, मित्र और कारणिकः यक्ष के साथ',
    'अमरकोश विशेष्यनिघ्नवर्ग — श्लोक २०३७, २०३८, २०३९, २०४०',
    'सत्रह शक्ति-शब्द — जैवातृकः से उन्मनाः तक',
    '१७ कथा-चित्र और दो अभ्यास-पृष्ठ — बड़ी तस्वीरें, संक्षिप्त हिन्दी पंक्तियाँ',
    'आर्यः स्वर्णमञ्जूषा च के पश्चात् यह तृतीय चित्र-कथा',
  ],
  contentsEn: [
    'Ārya’s mountain-cave quest with a sage, a friend, and a kāraṇikaḥ yakṣa',
    'Amarakosha Viśeṣyanighna — ślokas 2037–2040',
    'Seventeen power-words — from jaivātṛkaḥ to unmanāḥ',
    '17 story paintings and two activity pages — large pictures and concise Hindi lines',
    'The third picture story, following Āryaḥ Svarṇamañjūṣā ca',
  ],
};

export default function AryaRahasyamayiGuhaBook(props: AryaPictureBookProps) {
  return <AryaPictureBook {...props} config={RAHASYAMAYI_GUHA_CONFIG} />;
}
